module.exports.stateOptions = [
  { value: 'Alabama', label: 'AL' },
  { value: 'Alaska', label: 'AK' },
  { value: 'Arizona', label: 'AZ' },
  { value: 'Arkansas', label: 'AR' },
  { value: 'California', label: 'CA' },
  { value: 'Colorado', label: 'CO' },
  { value: 'Connecticut', label: 'CT' },
  { value: 'Delaware', label: 'DE' },
  { value: 'Florida', label: 'FL' },
  { value: 'Georgia', label: 'GA' },
  { value: 'Hawaii', label: 'HI' },
  { value: 'Idaho', label: 'ID' },
  { value: 'Illinois', label: 'IL' },
  { value: 'Indiana', label: 'IN' },
  { value: 'Iowa', label: 'IA' },
  { value: 'Kansas', label: 'KS' },
  { value: 'Kentucky', label: 'KY' },
  { value: 'Louisiana', label: 'LA' },
  { value: 'Maine', label: 'ME' },
  { value: 'Maryland', label: 'MD' },
  { value: 'Massachusetts', label: 'MA' },
  { value: 'Michigan', label: 'MI' },
  { value: 'Minnesota', label: 'MN' },
  { value: 'Mississippi', label: 'MS' },
  { value: 'Missouri', label: 'MO' },
  { value: 'Montana', label: 'MT' },
  { value: 'Nebraska', label: 'NE' },
  { value: 'Nevada', label: 'NV' },
  { value: 'New Hampshire', label: 'NH' },
  { value: 'New Jersey', label: 'NJ' },
  { value: 'New Mexico', label: 'NM' },
  { value: 'New York', label: 'NY' },
  { value: 'North Carolina', label: 'NC' },
  { value: 'North Dakota', label: 'ND' },
  { value: 'Ohio', label: 'OH' },
  { value: 'Oklahoma', label: 'OK' },
  { value: 'Oregon', label: 'OR' },
  { value: 'Pennsylvania', label: 'PA' },
  { value: 'Rhode Island', label: 'RI' },
  { value: 'South Carolina', label: 'SC' },
  { value: 'South Dakota', label: 'SD' },
  { value: 'Tennessee', label: 'TN' },
  { value: 'Texas', label: 'TX' },
  { value: 'Utah', label: 'UT' },
  { value: 'Vermont', label: 'VT' },
  { value: 'Virginia', label: 'VA' },
  { value: 'Washington', label: 'WA' },
  { value: 'Washington DC', label: 'DC' },
  { value: 'West Virginia', label: 'WV' },
  { value: 'Wisconsin', label: 'WI' },
  { value: 'Wyoming', label: 'WY' },
];

module.exports.stateOptionsFullNames = [
  { value: 'Alabama', label: 'Alabama' },
  { value: 'Alaska', label: 'Alaska' },
  { value: 'Arizona', label: 'Arizona' },
  { value: 'Arkansas', label: 'Arkansas' },
  { value: 'California', label: 'California' },
  { value: 'Colorado', label: 'Colorado' },
  { value: 'Connecticut', label: 'Connecticut' },
  { value: 'Delaware', label: 'Delaware' },
  { value: 'Florida', label: 'Florida' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Hawaii', label: 'Hawaii' },
  { value: 'Idaho', label: 'Idaho' },
  { value: 'Illinois', label: 'Illinois' },
  { value: 'Indiana', label: 'Indiana' },
  { value: 'Iowa', label: 'Iowa' },
  { value: 'Kansas', label: 'Kansas' },
  { value: 'Kentucky', label: 'Kentucky' },
  { value: 'Louisiana', label: 'Louisiana' },
  { value: 'Maine', label: 'Maine' },
  { value: 'Maryland', label: 'Maryland' },
  { value: 'Massachusetts', label: 'Massachusetts' },
  { value: 'Michigan', label: 'Michigan' },
  { value: 'Minnesota', label: 'Minnesota' },
  { value: 'Mississippi', label: 'Mississippi' },
  { value: 'Missouri', label: 'Missouri' },
  { value: 'Montana', label: 'Montana' },
  { value: 'Nebraska', label: 'Nebraska' },
  { value: 'Nevada', label: 'Nevada' },
  { value: 'New Hampshire', label: 'New Hampshire' },
  { value: 'New Jersey', label: 'New Jersey' },
  { value: 'New Mexico', label: 'New Mexico' },
  { value: 'New York', label: 'New York' },
  { value: 'North Carolina', label: 'North Carolina' },
  { value: 'North Dakota', label: 'North Dakota' },
  { value: 'Ohio', label: 'Ohio' },
  { value: 'Oklahoma', label: 'Oklahoma' },
  { value: 'Oregon', label: 'Oregon' },
  { value: 'Pennsylvania', label: 'Pennsylvania' },
  { value: 'Rhode Island', label: 'Rhode Island' },
  { value: 'South Carolina', label: 'South Carolina' },
  { value: 'South Dakota', label: 'South Dakota' },
  { value: 'Tennessee', label: 'Tennessee' },
  { value: 'Texas', label: 'Texas' },
  { value: 'Utah', label: 'Utah' },
  { value: 'Vermont', label: 'Vermont' },
  { value: 'Virginia', label: 'Virginia' },
  { value: 'Washington', label: 'Washington' },
  { value: 'Washington DC', label: 'Washington DC' },
  { value: 'West Virginia', label: 'West Virginia' },
  { value: 'Wisconsin', label: 'Wisconsin' },
  { value: 'Wyoming', label: 'Wyoming' },
];

module.exports.commodityOptions = [
  {
    value: 'agricultural_equipment',
    label: 'Agricultural Equipment',
  },
  {
    value: 'alcoholic_beverages',
    label: 'Alcoholic beverages (except beer and wine)',
  },
  {
    value: 'appliances',
    label: 'Appliances (except TV and stereos)',
  },
  {
    value: 'arms_ammunition_fireworks',
    label: 'Arms, ammunition, fireworks',
  },
  {
    value: 'automobile_parts_and_accessories',
    label: 'Automobile parts and accessories',
  },
  {
    value: 'automobiles_5_vehicles_or_less',
    label: 'Automobiles (5 vehicles or less)',
  },
  {
    value: 'automobiles_6_vehicles_or_more',
    label: 'Automobiles (6+ vehicles)',
  },
  { value: 'beer_and_wine', label: 'Beer and wine' },
  { value: 'beverages', label: 'Beverages (nonalcoholic)' },
  { value: 'building_materials', label: 'Building materials' },
  { value: 'bulk_or_bagged_nuts', label: 'Bulk or Bagged Nuts' },
  { value: 'cameras_and_film', label: 'Cameras and film' },
  { value: 'cannabis_cbd', label: 'Cannabis, CBD' },
  { value: 'canned_goods', label: 'Canned goods' },
  {
    value: 'sand',
    label: 'Sand',
  },
  {
    value: 'gravel',
    label: 'Gravel',
  },
  {
    value: 'dirt',
    label: 'Dirt',
  },
  {
    value: 'cement',
    label: 'Cement',
  },
  {
    value: 'chemicals_packaged_or_bulk',
    label: 'Chemicals (packaged or bulk)',
  },
  { value: 'china_and_ceramics', label: 'China and ceramics' },
  { value: 'cigarettes_and_cigars', label: 'Cigarettes and cigars' },
  { value: 'clothing', label: 'Clothing' },
  { value: 'coal', label: 'Coal' },
  { value: 'computers', label: 'Computers' },
  {
    value: 'contractors_heavy_equipment',
    label: 'Contractors heavy equipment',
  },
  { value: 'cosmetics_and_perfume', label: 'Cosmetics and perfume' },
  { value: 'cotton', label: 'Cotton' },
  { value: 'courier_documents', label: 'Courier Documents' },
  { value: 'cranes', label: 'Cranes' },
  { value: 'currency', label: 'Currency' },
  { value: 'dairy_products', label: 'Dairy products' },
  {
    value: 'dangerous_articles_explosives_corrosives_flammable_liquids',
    label: 'Dangerous articles, Explosives, Corrosives, Flammable Liquids',
  },
  {
    value: 'department_store_goods',
    label: 'Department Store Goods',
  },
  { value: 'documents', label: 'Documents' },
  { value: 'drugs', label: 'Drugs (except narcotics)' },
  { value: 'dry_goods', label: 'Dry goods' },
  { value: 'eggs_shell', label: 'Eggs (shell)' },
  {
    value: 'electrical_supplies_and_fixtures',
    label: 'Electrical supplies and fixtures',
  },
  { value: 'empty_trailers', label: 'Empty Trailers' },
  { value: 'farm_products', label: 'Farm products' },
  { value: 'fertilizer', label: 'Fertilizer' },
  { value: 'fine_arts', label: 'Fine arts' },
  { value: 'food_products', label: 'Food products' },
  { value: 'fracking', label: 'Fracking' },
  {
    value: 'frozen_or_refrigerated',
    label: 'Frozen or refrigerated',
  },
  { value: 'furniture', label: 'Furniture' },
  { value: 'furs', label: 'Furs' },
  { value: 'general_merchandise', label: 'General merchandise' },
  { value: 'glassware', label: 'Glassware' },
  { value: 'grain_hay_feed', label: 'Grain, hay, feed' },
  { value: 'hanging_meat', label: 'Hanging Meat' },
  { value: 'hardware_and_paint', label: 'Hardware and paint' },
  { value: 'hazmat', label: 'Hazmat' },
  { value: 'household_effects', label: 'Household Effects' },
  {
    value: 'household_goods',
    label: 'Household Goods (Residential Delivery)',
  },
  { value: 'intermodal_containers', label: 'Intermodal Containers' },
  { value: 'jewelry', label: 'Jewelry' },
  {
    value: 'ladies_and_mens_dress_apparel',
    label: 'Ladies and mens dress apparel',
  },
  { value: 'leather_goods', label: 'Leather goods (except shoes)' },
  {
    value: 'liquid_haulers',
    label: 'Liquid haulers (bulk nonflammable)',
  },
  {
    value: 'livestock_and_live_poultry',
    label: 'Livestock and live poultry',
  },
  { value: 'logs', label: 'Logs' },
  { value: 'lumber', label: 'Lumber' },
  { value: 'machinery_light', label: 'Machinery (light)' },
  {
    value: 'machinery_and_heavy_equipment',
    label: 'Machinery and heavy equipment',
  },
  { value: 'meat', label: 'Meat' },
  { value: 'metal_and steel', label: 'Metal and steel' },
  { value: 'mobile_homes', label: 'Mobile Homes' },
  { value: 'narcotics', label: 'Narcotics' },
  { value: 'non-ferrous_metal', label: 'Non-Ferrous Metal' },
  {
    value: 'nursery-plants_trees_flowers',
    label: 'Nursery-Plants, Trees, Flowers',
  },
  { value: 'office_equipment', label: 'Office equipment' },
  {
    value: 'paper_and_paper_products',
    label: 'Paper and paper products',
  },
  { value: 'people', label: 'People' },
  {
    value: 'petroleum_products',
    label: 'Petroleum products (under 140 degrees flashpoint)',
  },
  { value: 'pipe_cable_and_wire', label: 'Pipe, cable, and wire' },
  { value: 'plumbing_supplies', label: 'Plumbing supplies' },
  {
    value: 'plastic_and_plastic_products',
    label: 'Plastic and plastic products',
  },
  { value: 'poultry', label: 'Poultry (dressed)' },
  { value: 'power_tools', label: 'Power tools' },
  { value: 'precious_metals', label: 'Precious metals' },
  { value: 'precious_stones', label: 'Precious stones' },
  { value: 'produce', label: 'Produce' },
  {
    value: 'recreational_vehicles_boats_rvs',
    label: 'Recreational Vehicles, boats, RVS',
  },
  { value: 'refuse_garbage', label: 'Refuse, Garbage' },
  {
    value: 'rugs_and_carpets_oriental',
    label: 'Rugs and carpets (Oriental)',
  },
  {
    value: 'rugs_and_carpets',
    label: 'Rugs and carpets (other than Oriental)',
  },
  { value: 'scrap_metal', label: 'Scrap Metal' },
  { value: 'seafood_canned', label: 'Seafood Canned' },
  { value: 'seafood_fresh', label: 'Seafood Fresh' },
  { value: 'seafood_frozen', label: 'Seafood Frozen' },
  { value: 'seafood_shellfish', label: 'Seafood Shellfish' },
  { value: 'seafood', label: 'Seafood' },
  { value: 'shoes', label: 'Shoes' },
  {
    value: 'specialized_heavy_haulers',
    label: 'Specialized heavy haulers',
  },
  {
    value: 'sporting_goods_and_toys',
    label: 'Sporting goods and toys',
  },
  { value: 'textiles', label: 'Textiles' },
  { value: 'tires_and_tubes', label: 'Tires and tubes' },
  { value: 'tobacco', label: 'Tobacco' },
  {
    value: 'tv_radios_and_stereo_equipment',
    label: 'TV, radios, and stereo equipment',
  },
  { value: 'us_mail', label: 'US Mail' },
  {
    value: 'video_equipment_and_tapes',
    label: 'Video equipment and tapes',
  },

  {
    value: "containerized_freight_accelerant_only",
    label: "Containerized Freight (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "hazardous_waste_accelerant_only",
    label: "Hazardous Waste (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "ice_cream_frozen_desserts_accelerant_only",
    label: "Ice Cream and Frozen Desserts (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "mail_package_contract_haulers_accelerant_only",
    label: "Mail/Package Contract Haulers (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "medical_equipment_accelerant_only",
    label: "Medical Equipment (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "medical_waste_accelerant_only",
    label: "Medical Waste (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "milk_raw_accelerant_only",
    label: "Milk - Raw (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "mix_in_transit_accelerant_only",
    label: "Mix In Transit (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "municipal_waste_accelerant_only",
    label: "Municipal Waste (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "salt_accelerant_only",
    label: "Salt (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "temperature_sensitive_pharmaceuticals_accelerant_only",
    label: "Temperature-Sensitive Pharmaceuticals (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "trusses_accelerant_only",
    label: "Trusses (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "asphalt_accelerant_only",
    label: "Asphalt (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "explosives_accelerant_only",
    label: "Explosives (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "corrosives_accelerant_only",
    label: "Corrosives (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "compressed_gases_accelerant_only",
    label: "Compressed Gases (Propane, Oxygen Tanks) (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "oxidizers_organic_peroxides_accelerant_only",
    label: "Oxidizers/Organic Peroxides (Accelerant Only)",
    forAccelerantOnly: true
  },  
  {
    value: "radioactive_materials_accelerant_only",
    label: "Radioactive Materials (Accelerant Only)",
    forAccelerantOnly: true
  },
  {
    value: "dangerous_articles_explosives_corrosives_flammable_liquids_accelerant_only",
    label: "Dangerous articles, Explosives, Corrosives, Flammable Liquids (Accelerant Only)",
    forAccelerantOnly: true
  },
];

module.exports.classOptions = [
  {
    value: '1',
    label: 'Class 1: 0–6,000 pounds (0–2,722 kg)',
  },
  {
    value: '2a',
    label: 'Class 2a: 6,001–8,500 pounds (2,722–3,856 kg)',
  },
  {
    value: '2b',
    label: 'Class 2b: 8,501–10,000 pounds (3,856–4,536 kg)',
  },
  {
    value: '3',
    label: 'Class 3: 10,001–14,000 pounds (4,536–6,350 kg)',
  },
  {
    value: '4',
    label: 'Class 4: 14,001–16,000 pounds (6,351–7,257 kg)',
  },
  {
    value: '5',
    label: 'Class 5: 16,001–19,500 pounds (7,258–8,845 kg)',
  },
  {
    value: '6',
    label: 'Class 6: 19,501–26,000 pounds (8,846–11,793 kg)',
  },
  {
    value: '7',
    label: 'Class 7: 26,001–33,000 pounds (11,794–14,969 kg)',
  },
  {
    value: '8',
    label: 'Class 8: 33,001 pounds (14,969 kg) +',
  },
];

module.exports.vehiclesBodytype = [
  { value: 'tractor', label: 'Tractor' },
  { value: 'boom_truck', label: 'Boom Truck' },
  { value: 'box_truck', label: 'Box Truck' },
  { value: 'bucket_truck', label: 'Bucket Truck' },
  { value: 'bus', label: 'Bus' },
  {
    value: 'catering_truck',
    label: 'Catering Truck',
  },
  { value: 'cement_truck', label: 'Cement Truck' },
  {
    value: 'delivery_truck',
    label: 'Delivery Truck',
  },
  { value: 'delivery_van', label: 'Delivery Van' },
  { value: 'dump_truck', label: 'Dump Truck' },
  { value: 'fire_truck', label: 'Fire Truck' },
  {
    value: 'flatbed_tow_truck',
    label: 'Flatbed Tow Truck',
  },
  { value: 'flatbed_truck', label: 'Flatbed Truck' },
  { value: 'food_truck', label: 'Food Truck' },
  {
    value: 'fuel_tank_truck',
    label: 'Fuel Tank Truck',
  },
  { value: 'garbage_truck', label: 'Garbage Truck' },
  {
    value: 'landscape_truck',
    label: 'Landscape Truck',
  },
  { value: 'logging_truck', label: 'Logging Truck' },
  {
    value: 'milk_tanker_truck',
    label: 'Milk Tanker Truck',
  },
  { value: 'mini_van', label: 'Mini Van' },
  { value: 'moving_truck', label: 'Moving Truck' },
  { value: 'pick_up', label: 'Pickup' },
  {
    value: 'on_hook_tow_truck',
    label: 'On Hook Tow Truck',
  },
  { value: 'rack_truck', label: 'Rack Truck' },
  {
    value: 'snow_plow_truck',
    label: 'Snow Plow Truck',
  },
  { value: 'stake_truck', label: 'Stake Truck' },
  { value: 'step_van', label: 'Step Van' },
  { value: 'suv', label: 'SUV' },
  { value: 'tanker_truck', label: 'Tanker Truck' },
  { value: 'utility_van', label: 'Utility Van' },
];

module.exports.trailersBodytype = [
  {
    value: 'auto_transporter_trailer',
    label: 'Auto Transporter Trailer',
  },
  { value: 'chip_trailer', label: 'Chip Trailer' },
  { value: 'curtain_van_trailer', label: 'Curtain Van Trailer' },
  { value: 'double_van_trailer', label: 'Double Van Trailer' },
  { value: 'dry_bulk_trailer', label: 'Dry Bulk Trailer' },
  { value: 'dry_van_trailer', label: 'Dry Van Trailer' },
  { value: 'dump_trailer', label: 'Dump Trailer' },
  { value: 'flatbed_trailer', label: 'Flatbed Trailer' },
  { value: 'gooseneck_trailer', label: 'Gooseneck Trailer' },
  { value: 'hopper_trailer', label: 'Hopper Trailer' },
  {
    value: 'intermodal_container_hauler_trailer',
    label: 'Intermodal Container Hauler Trailer',
  },
  { value: 'logging_trailer', label: 'Logging Trailer' },
  { value: 'low_boy_trailer', label: 'Low Boy Trailer' },
  { value: 'pup_trailer', label: 'Pup Trailer' },
  {
    value: 'refrigerated_van_trailer',
    label: 'Refrigerated Van Trailer',
  },
  { value: 'step_deck_trailer', label: 'Step Deck Trailer' },
  { value: 'tanker_trailer', label: 'Tanker Trailer' },
  { value: 'tilt_deck_trailer', label: 'Tilt deck Trailer' },
  { value: 'triple_van_trailer', label: 'Triple Van Trailer' },
  { value: 'utility_trailer', label: 'Utility Trailer' },
];

module.exports.entityTypesOptions = [
  { value: 'individual', label: 'Individual' },
  { value: 'corporation', label: 'Corporation' },
  { value: 'llc', label: 'LLC' },
  { value: 'joint_venture', label: 'Joint Venture' },
  { value: 'partnership', label: 'Partnership' },
];

module.exports.dataSharingOptions = [
  { value: 'dash_cam_dual_ai_connected', label: 'Dash Camera' },
  { value: 'eld_only', label: 'ELD Only' },
];

module.exports.vendorNameOptions = [
  { value: 'none', label: 'None' },
  { value: 'Not On List', label: 'Not On List' },
  { value: 'ActSoft', label: 'ActSoft' },
  { value: 'Azuga', label: 'Azuga' },
  {
    value: 'Cambridge Mobile Telematics',
    label: 'Cambridge Mobile Telematics',
  },
  { value: 'CarrierWeb', label: 'CarrierWeb' },
  { value: 'Cartasite', label: 'Cartasite' },
  { value: 'eRoad', label: 'eRoad' },
  { value: 'Fleet Complete', label: 'Fleet Complete' },
  { value: 'FleetDaddy', label: 'FleetDaddy' },
  { value: 'Fleetmatics', label: 'Fleetmatics' },
  { value: 'Fleetsharp (Agilis)', label: 'Fleetsharp (Agilis)' },
  { value: 'Geotab', label: 'Geotab' },
  { value: 'GPS Insight', label: 'GPS Insight' },
  { value: 'GPS Trackit (3.6)', label: 'GPS Trackit (3.6)' },
  { value: 'InTouch GPS (P4)', label: 'InTouch GPS (P4)' },
  { value: 'JJ Keller', label: 'JJ Keller' },
  { value: 'KeepTruckin', label: 'KeepTruckin' },
  { value: 'LinxUp (Agilis)', label: 'LinxUp (Agilis)' },
  { value: 'Networkfleet', label: 'Networkfleet' },
  { value: 'Nextraq', label: 'Nextraq' },
  { value: 'Omnitracs', label: 'Omnitracs' },
  { value: 'Orbcomm', label: 'Orbcomm' },
  { value: 'PeopleNet', label: 'PeopleNet' },
  { value: 'Qv21', label: 'Qv21' },
  { value: 'Rand McNally', label: 'Rand McNally' },
  { value: 'Samsara', label: 'Samsara' },
  { value: 'Simple Truck ELD', label: 'Simple Truck ELD' },
  { value: 'Spireon/FleetLocate', label: 'Spireon/FleetLocate' },
  {
    value: 'Teletrac Navman Fleet Director',
    label: 'Teletrac Navman Fleet Director',
  },
  {
    value: 'Teletrac Navman Director',
    label: 'Teletrac Navman Director',
  },
  { value: 'Telogis', label: 'Telogis' },
  { value: 'TeMeDa', label: 'TeMeDa' },
  { value: 'TomTom', label: 'TomTom' },
  { value: 'Transflow', label: 'Transflow' },
  {
    value: 'Vehicle Tracking Solutions',
    label: 'Vehicle Tracking Solutions',
  },
  { value: 'Workwave', label: 'Workwave' },
  { value: 'XRS', label: 'XRS' },
  { value: 'Zonar Systems', label: 'Zonar Systems' },
  { value: 'Zubie', label: 'Zubie' },
];

const coverWhaleEldProviderNames = [
  "3PL TEK",
  "ABC ELD",
  "Action ELD",
  "ADA ELD",
  "Advantage Knights ELD",
  "Advantage One",
  "AI ELD",
  "AirELD",
  "Alfa ELD",
  "Allways Track",
  "Alpha E-Logbook",
  "Amber ELD",
  "AMPM ELD",
  "Apex ELD",
  "Apex Ultima",
  "Apollo Compass",
  "Apollo ELD",
  "Argos Connected Solutions",
  "AT ELD",
  "Attrix",
  "AUTOGRI ELD",
  "Avanguard ELD",
  "Axion Route",
  "Azuga",
  "BigRoad",
  "Bison Elog",
  "Black Bear",
  "Blue Arrow Telematics",
  "Blue Horse ELD",
  "Blue Ink Tech",
  "Blue Star ELD",
  "Captain ELD",
  "ClearPathGPS",
  "Club ELD",
  "Cobra ELD",
  "Columbus ELD",
  "CommandGPS",
  "Conti-GO",
  "Daily ELD",
  "Daily ELD Plus",
  "DFL ELD",
  "Digital ELD",
  "DLog ELD",
  "Dragon ELD",
  "Dream ELD",
  "DriveSafe ELD",
  "DSG Elogs",
  "DY ELD",
  "DY+ ELD",
  "Dynamic ELD",
  "Eagle Wireless",
  "eBlue Sun Logs",
  "Egreen ELD",
  "ELD Books",
  "ELD Connection",
  "ELD Desired",
  "ELD for You",
  "ELD Mandate HOS",
  "ELD Mandate Prime",
  "ELD Mandate Pro",
  "ELD One",
  "ELD Pro Solution",
  "ELD Rider",
  "ELD2GO",
  "ELD4Trucking",
  "ELD88",
  "ELD99",
  "ELDRoad",
  "ELDTREX",
  "Elog42",
  "Empire Logs",
  "Envision ELD",
  "EnVue Telematics",
  "EROAD",
  "EVA ELD",
  "EVO ELD",
  "Express Way ELD",
  "Extreme ELD",
  "Ezlogz",
  "Factor ELD",
  "First ELD",
  "FIRSTGATE ELD",
  "Flash ELogs",
  "Fleet Complete Hub",
  "Fleet Profit Center",
  "FleetHunt",
  "Fleetistics",
  "FleetPulse",
  "FleetSharp",
  "FLEX ELD",
  "FM ELD",
  "Fort Knox ELD",
  "Forza ELD",
  "Geotab",
  "Geotab AT&T",
  "Globcom ELD",
  "GoFleet",
  "GoGPS",
  "GPS Insight",
  "GPS Tracking Canada",
  "GPSTab",
  "Grand ELD",
  "GrayBox Solutions",
  "Green Light ELD",
  "Gridline",
  "GT ELD",
  "Hero ELD",
  "High Point GPS",
  "Highest ELD",
  "HOS Reporter Plus",
  "HOS247",
  "ID ELD",
  "ILog ELD",
  "Infinity ELD",
  "IntelliShift",
  "Intime ELD",
  "IoTab",
  "Ironman ELD",
  "ISAAC Instruments",
  "Just ELD",
  "Konexial",
  "KSK ELD",
  "Leader ELD",
  "Legacy ELD",
  "Light & Travel ELD",
  "Linxup",
  "Log Plus ELD",
  "loopELD",
  "Lucid ELD",
  "Lytx",
  "Maestral ELD",
  "Map ELOG Corp",
  "MasterELD",
  "Matrack",
  "MAX ELD",
  "MICHELIN Connected Fleet",
  "Monarch Tracking",
  "Moonlight ELD",
  "Motion ELD",
  "Motive",
  "MOTOsafety",
  "Mountain ELD",
  "MyWay ELD",
  "Netradyne",
  "Nexar",
  "Next Fleet ELD",
  "Noor ELD",
  "Novio ELD",
  "Omega ELD",
  "Omnitracs ES",
  "Omnitracs XRS",
  "OneStep GPS",
  "Ontime ELD",
  "Optima ELD",
  "Orient ELD",
  "Orient Star ELD",
  "Panda ELD",
  "Paragon ELD",
  "PDSINC ELD",
  "Peak ELD",
  "PeopleNet",
  "Phoenix ELD",
  "Pioneer ELD Solution",
  "Platinum ELD",
  "PoP ELD",
  "PowerTrucks ELD",
  "Premium ELD",
  "Prestige ELD",
  "Pro Ride ELD",
  "Project ELD",
  "ProLogs",
  "ProTracking ELD",
  "PTI ELD",
  "Quick Elogs ELD",
  "Radical ELD",
  "Rand McNally DriverConnect",
  "Raven Connected",
  "ReadySet Papeld",
  "RealELD",
  "RedFox ELD",
  "Regulog ELD",
  "Reliable ELD",
  "Renaissance ELD",
  "Ridehub ELD",
  "Rigbot",
  "RoadStar",
  "Robinhood ELD",
  "Rock ELD",
  "Route ELD",
  "Route One ELD",
  "RouteMate",
  "Royal ELD",
  "Run ELD",
  "Safe Lane ELD",
  "Samsara",
  "SBA ELD",
  "Secure Path ELD",
  "SF ELD",
  "Sharp ELD",
  "Simba ELD",
  "Simple Way ELD",
  "Simplex ELD2Go",
  "Smart Choice Logs",
  "SmartDrive",
  "Smartelds",
  "Solution ELD",
  "Sparkle ELD",
  "Speedline ELD",
  "Spireon FleetLocate",
  "SR ELD",
  "Startrucks ELD",
  "Starway ELD",
  "State ELOG",
  "Sunset Logbook",
  "Support ELD",
  "Surfsight",
  "Swift ELD",
  "Switchboard",
  "Synergy ELD",
  "Teddy ELD",
  "Teletrac Navman 360",
  "Teletrac Navman Director",
  "Tempus ELD",
  "TFM ELD",
  "Top Compliance ELD",
  "Top Tracking System",
  "Track Truck ELD",
  "Trackease",
  "TrackEnsure",
  "Traclog ELD Solutions",
  "Transflo",
  "Transit ELD",
  "Truckford ELD",
  "Truckstaff ELD",
  "TruckX",
  "True Road ELD",
  "Trust ELD",
  "TT ELD",
  "TX ELD",
  "Under Control ELD",
  "Unique ELD",
  "Unity ELD",
  "US Power ELD",
  "USfast ELD",
  "UzbPrime ELD",
  "Verizon Connect Fleet",
  "Verizon Connect Reveal",
  "Vista ELD",
  "Vitality ELD",
  "Vlog ELD",
  "Vulcansols",
  "WBCS Group LLC",
  "Webfleet",
  "Wex Telematics",
  "Wizefleet ELD",
  "XELD",
  "Xpert Logs",
  "Xplore ELD",
  "YouLog ELD",
  "Zaphira ELD",
  "Zenith ELD",
  "Zero ELD",
  "Zeromax ELD",
  "Zippy ELD",
  "Zonar",
];

const coverWhaleEldVendorCodeOverrides = {
  "Alpha E-Logbook": "alpha-eld",
  "Argos Connected Solutions": "argos",
  "Axion Route": "mgk-eld",
  "Blue Arrow Telematics": "blue-arrow",
  "Blue Ink Tech": "blue-ink",
  "ClearPathGPS": "clear-path-gps",
  "CommandGPS": "command-gps",
  "DriveSafe ELD": "drive-safe-eld",
  "DY+ ELD": "dyplus-eld",
  "Egreen ELD": "egreen-eld-v2",
  "ELD One": "eldone",
  "ELD2GO": "eld-2-go",
  Ezlogz: "ez-logz",
  "Factor ELD": "factor-eld-v2",
  FleetPulse: "fleet-pulse",
  "Fort Knox ELD": "fort-knox",
  "Geotab AT&T": "geotab-att",
  "ILog ELD": "ilog-eld-v2",
  IntelliShift: "intelli-shift",
  IoTab: "io-tab",
  "ISAAC Instruments": "isaac",
  "KSK ELD": "ksk",
  "Light & Travel ELD": "light-and-travel-eld",
  loopELD: "loop-eld",
  MasterELD: "master-eld",
  MOTOsafety: "moto-safety",
  "OneStep GPS": "one-step-gps",
  PeopleNet: "people-net",
  "Rand McNally DriverConnect": "rand-mcnally-driver-connect",
  "ReadySet Papeld": "readyset-pap-eld",
  RealELD: "real-eld",
  "Simple Way ELD": "simpleway-eld",
  "Simplex ELD2Go": "simplex",
  SmartDrive: "smart-drive",
  "Spireon FleetLocate": "spireon-fleet-locate",
  TrackEnsure: "track-ensure",
  "US Power ELD": "uspower-eld",
  "Verizon Connect Fleet": "verizon-fleet",
  "Verizon Connect Reveal": "verizon-reveal",
  "WBCS Group LLC": "secure-eld",
};

const coverWhaleEldNameToCode = (name) =>
  coverWhaleEldVendorCodeOverrides[name] ||
  name.toLowerCase().replace(/\s+/g, "-");

module.exports.coverWhaleEldProviderOptions = [
  ...coverWhaleEldProviderNames.map((name) => ({
    value: coverWhaleEldNameToCode(name),
    label: name,
  })),
  { value: "other", label: "Other" },
];

module.exports.limitTowingStorageOptions = [
  { value: '2500', label: '$ 2,500' },
  { value: '5000', label: '$ 5,000' },
  { value: '7500', label: '$ 7,500' },
  { value: '10000', label: '$ 10,000' },
  { value: '15000', label: '$ 15,000' },
  { value: '20000', label: '$ 20,000' },
  { value: '25000', label: '$ 25,000' },
];

module.exports.trailerInterchangeLimitOptions = [
  { value: '20000', label: '$ 20,000' },
  { value: '25000', label: '$ 25,000' },
  { value: '30000', label: '$ 30,000' },
  { value: '35000', label: '$ 35,000' },
  { value: '40000', label: '$ 40,000' },
  { value: '45000', label: '$ 45,000' },
  { value: '50000', label: '$ 50,000' },
  { value: '55000', label: '$ 55,000' },
  { value: '60000', label: '$ 60,000' },
  { value: '65000', label: '$ 65,000' },
  { value: '70000', label: '$ 70,000' },
  { value: '75000', label: '$ 75,000' },
  { value: '80000', label: '$ 80,000' },
  { value: '85000', label: '$ 85,000' },
  { value: '90000', label: '$ 90,000' },
  { value: '95000', label: '$ 95,000' },
  { value: '100000', label: '$ 100,000' },
];

module.exports.limitAutoLiabilityOptions = [
  { value: '1000000', label: '$ 1,000,000' },
  { value: '750000', label: '$ 750,000' },
];

module.exports.limitAutoLiabilityOptionsForCoverWhaleAndNirvana = [
  { value: '1500000', label: '$ 1,500,000' },
  { value: '1000000', label: '$ 1,000,000' },
  { value: '750000', label: '$ 750,000' },
];

// $750k, $1M, $1.5M and $2M
module.exports.limitAutoLiabilityOptionsForProgressive = [
  { value: '750000', label: '$ 750,000' },
  { value: '1000000', label: '$ 1,000,000' },
  { value: '1500000', label: '$ 1,500,000' },
  { value: '2000000', label: '$ 2,000,000' },
];

module.exports.account_sources = [
  { value: 'facebook', label: 'Facebook' },
  { value: 'cw_referral', label: 'Cover Whale Referral' },
  { value: 'cb_website', label: 'Cover Badger Website' },
  { value: 'other', label: 'Other' }
]

module.exports.limitMotorTruckCargoOptions = [
  { value: '0', label: 'No, Excluded' },
  { value: '100000', label: '$ 100,000' },
  { value: '125000', label: '$ 125,000' },
  { value: '150000', label: '$ 150,000' },
  { value: '175000', label: '$ 175,000' },
  { value: '200000', label: '$ 200,000' },
  { value: '250000', label: '$ 250,000' },
];

module.exports.mtcDeductableLimitOptions = [
  { value: '1000', label: '$ 1,000' },
  { value: '2500', label: '$ 2,500' },
];

module.exports.stateOperations = [
  { value: 'intrastate', label: 'Intrastate' },
  { value: 'interstate', label: 'Interstate' },
  { value: 'all', label: 'All' },
];
